export const getErrorInfo = (error?: string) => {
  if (error === 'NO_MATCHES_AVAILABLE') {
    return {
      title: 'No matches',
      description: 'No matches The system cannot proceed as no matches are available',
    };
  }

  if (error === 'ALL_MATCHES_ALREADY_AWARDED') {
    return {
      title: 'All matches are already issued',
      description: 'The system cannot proceed as all matches are already issued',
    };
  }

  return {
    title: 'Partial matches available',
    description: 'The system cannot proceed as one or more partial matches are available. Please make sure that all matches are in Full match status and try again',
  };
};
